import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait until /users/me (and Firebase) have settled — not only Firebase session
  return new Promise<boolean>((resolve) => {
    const checkInterval = setInterval(() => {
      if (!authService.isLoading()) {
        clearInterval(checkInterval);
        if (authService.isAuthenticated()) {
          resolve(true);
        } else {
          router.navigate(['/login']);
          resolve(false);
        }
      }
    }, 50);
  });
};
